<template>
	<a-layout-header class="header">
		<a href="/" class="logo"></a>

		<a-menu v-show="token" theme="dark" mode="horizontal" :style="{ marginLeft: '50px', lineHeight: '64px' }"
			@click="onMenuClick" :selectedKeys="selectedKeys">
			<a-menu-item key="match">{{ $t('nav.live') }}</a-menu-item>
			<a-menu-item key="settings">{{ $t('nav.settings') }}</a-menu-item>
		</a-menu>

		<div style="flex: 1" />

		<a-menu v-if="!token" theme="dark" mode="horizontal" :style="{ lineHeight: '64px' }" @click="onMenuClick"
			:selectedKeys="selectedKeys">
			<a-menu-item key="login">{{ $t('nav.login') }}</a-menu-item>
		</a-menu>

		<a-menu v-else theme="dark" mode="horizontal" :style="{ lineHeight: '64px' }" @click="onMenuClick"
			:selectedKeys="[]">
			<!-- <a-sub-menu key="tutorial">
				<span slot="title">
					{{ $t('nav.tutorial') }}
					<a-icon type="down" />
				</span>
				<a-menu-item key="tutorial_obs">{{ $t('nav.tutorial_obs') }}</a-menu-item>
				<a-menu-item key="tutorial_listing">{{ $t('nav.tutorial_listing') }}</a-menu-item>
			</a-sub-menu> -->
			<a-menu-item key="username">
				<a-avatar :src="minfo.face" :size="24"></a-avatar>
				{{ minfo.username }}
			</a-menu-item>
			<a-menu-item key="logout">
				<a-icon type="poweroff" />
				{{ $t('nav.logout') }}
			</a-menu-item>
		</a-menu>

		<!-- <a-menu theme="dark" mode="horizontal" :style="{ lineHeight: '64px', marginLeft: '20px' }" @click="onMenuClick">
			<a-sub-menu key="language">
				<span slot="title">{{ $t('nav.language') }}</span>
				<a-menu-item key="zh-CN">简体中文</a-menu-item>
				<a-menu-item key="en-US">English</a-menu-item>
			</a-sub-menu>
		</a-menu> -->
	</a-layout-header>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment';
import { clearCookie } from '@/utils'
export default {
	components: {},
	data() {
		return {
			menus: [
				{
					key: 'match',
					text: '赛事开播'
				},
				{
					key: 'settings',
					text: '设置'
				}
			]
		};
	},
	computed: {
		routeName() {
			return this.$route.name;
		},
		selectedKeys() {
			if (this.menus.map(v => v.key).includes(this.routeName)) {
				return [this.routeName];
			} else {
				return [];
			}
		},
		...mapState(['token', 'minfo'])
	},
	methods: {
		onMenuClick(menu) {
			// if (menu.key == 'tutorial_obs') {
			// 	return window.open('https://cdn.ligalive365.com/tutorial/Liga_Live_OBS_Streaming_Tutorial.pdf?v1');
			// } else if (menu.key == 'tutorial_listing') {
			// 	return window.open('https://cdn.ligalive365.com/tutorial/Liga_Live_Event_Management_Tutorial.pdf');
			// }

			if (this.$route.name == menu.key || ['username'].includes(menu.key)) {
				return;
			}
			if (['zh-CN', 'en-US'].includes(menu.key)) {
				this.$storage.set('language', menu.key);
				location.reload();
				return;
			}
			if (menu.key == 'logout') {
				this.$confirm({
					content: this.$t('nav.logout_confirm'),
					onOk: () => {
						clearCookie()
						this.$storage.clear();
						this.$store.dispatch('setToken', false);
						location.replace('/');
					}
				});
				return;
			}

			if (this.$store.state.token) {
				if (this.menus.map(v => v.key).includes(menu.key)) {
					this.$router.push({
						name: menu.key
					});
				}
			}
		}
	}
};
</script>

<style lang="less">
.header {
	display: flex;
	flex-direction: row;

	.logo {
		padding: 0 50px 0 140px;
		height: 64px;
		margin-right: 28px;
		float: left;
		color: #fff;
		font-size: 18px;
		font-weight: bold;
		text-transform: uppercase;
		background: url(../assets/images/logo.png) no-repeat left center;
		background-size: auto 60%;
	}
}
</style>
